import { render, staticRenderFns } from "./EmployeeFormSubmissionEmployeeCard.vue?vue&type=template&id=0dcc04bf&"
import script from "./EmployeeFormSubmissionEmployeeCard.vue?vue&type=script&lang=ts&"
export * from "./EmployeeFormSubmissionEmployeeCard.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeFormSubmissionEmployeeCard.vue?vue&type=style&index=0&id=0dcc04bf&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports